import { render, staticRenderFns } from "./BaseScreen.vue?vue&type=template&id=4cea3699&scoped=true"
import script from "./BaseScreen.vue?vue&type=script&lang=js"
export * from "./BaseScreen.vue?vue&type=script&lang=js"
import style0 from "./BaseScreen.vue?vue&type=style&index=0&id=4cea3699&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea3699",
  null
  
)

export default component.exports